import { makeObservable, observable } from 'mobx';
import { API } from '~/api';
import { GridStateModel } from '~/model/model.gridstate';
import { Singleton } from '~/shared/service/service.base';
import { Async } from '~/shared/tools/async';
import { ApiService } from './service.api';

@Singleton()
export class PartnerService {
	readonly items = observable.array([] as API.Partner[], { deep: false });
	readonly async = new Async();
	readonly gridState = new GridStateModel('partners');

	@observable totalCount = 0;

	constructor(private api: ApiService) {
		makeObservable(this);
	}

	loacdAndSubscribe = () => {
		this.reload();
		return this.gridState.subscribe(this.reload);
	};

	reload = () => {
		this.async.call(async () => {
			const { data } = await this.api.partnerGetAll({
				limit: this.gridState.pageSize,
				offset: this.gridState.offset,
				// filter: this.gridState.filterQuery,
				// sort: this.gridState.sort,
				// sortDir: this.gridState.sortDir,
			});
			return () => {
				this.items.replace(data.items);
				this.totalCount = data.total;
			};
		});
	};

	async getOne(id: number | undefined) {
		if (id === undefined) return;
		return this.async.exec(() => this.api.partnerGetOne(id).then(resp => resp.data));
	}

	async update(id: number, data: API.PartnerUpdateDto) {
		return this.async.exec(async () => {
			await this.api.uploadImg(data.avatar);
			await this.api.partnerUpdate(id, data);
		});
	}

	delete = async (id: number) => {
		return this.async.exec(() => this.api.partnerDelete(id)).then(this.reload);
	};
}
